import React from "react";
import "styled-components/macro";
import { useGA } from "modules/ga-provider";

import Header from "components/header";
import SupportCta from "components/support-cta";

function Footer() {
  return (
    <footer className="flex w-full h-20 p-4 border-t">
      <div className="w-1/4"></div>
      <div className="flex items-center justify-center w-2/4">
        Timesafe © 2020
      </div>
      <div className="w-1/4"></div>
    </footer>
  );
}

function BoardingLayout(props) {
  const { children, wizard, cta } = props;

  const [pageView] = useGA();
  React.useEffect(() => {
    pageView();
  }, [pageView]);

  return (
    <div
      className="
        h-full 
        flex
        flex-col
      "
    >
      <div
        className="
          fixed
          top-0
          left-0
          right-0
          z-50
        "
      >
        <Header wizard={wizard} cta={cta} />
      </div>
      <div
        className="
          h-full
          flex
          flex-col
        "
      >
        <div
          className="
            pt-20
            flex-1
            mb-16
            mt-32
            sm:mt-20
            lg:mt-16
          "
        >
          {children}
        </div>
        <div className="mb-8">
          <SupportCta />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default BoardingLayout;
